import { apiService } from "carynhealth-component-library";
import {
  getLocalStorage,
  setLocalStorage,
} from "carynhealth-component-library/dist/cjs/helpers/storage";
import config from "../../../config/constants/config";
import messages from "../../../config/constants/messages";
import { tilesInfo } from "./data";
import { Auth } from "aws-amplify";
import { getPlainIData } from "../../RightTopMemberTabs/handler";
import { getMemberHealthIdCard } from "../../ProgramInformation/handlers";
import i18next from "i18next";

export const getProductTiles = async () => {
  if (config.APP_NAME === config.BRAND_NETWELL)
    return {
      tiles: Object.values(tilesInfo.NETWELL),
      errorMessage: "",
    };
  if (config.APP_NAME === config.BRAND_CURAMLIFE) {
    return {
      tiles: Object.values(tilesInfo.CURAMLIFE),
      errorMessage: "",
    };
  }
  try {
    const isNetwell = config.APP_NAME === config.BRAND_NETWELL;
    const id = isNetwell
      ? config.DEFAULT_VALUES.NETWELL_TILES_ID
      : getLocalStorage("CLIENT_ID");
    const request = {
      URL: config.URLS.baseV7API + config.URLS.memberPortal + id,
      brand: config.APP_NAME,
    };
    const { data: apiResponse } = await apiService.default.get(request);

    /** Define tiles array if tile name exists in API Response */
    const getTileNames = apiResponse?.response?.map(
      (tile: any) => tile.cardtitle
    );
    const brandRelatedTiles: any | [] = [];

    getTileNames.forEach((tile: string) => {
      const data = (
        tilesInfo[config.APP_NAME as keyof typeof tilesInfo] as any
      )[tile];
      if (data) {
        brandRelatedTiles.push(data);
      }
    });

    return {
      tiles: brandRelatedTiles,
      errorMessage: "",
    };
  } catch (error: any) {
    console.log(error);
    return Promise.reject({
      errorMessage: messages.SOMETHING_WRONG,
    });
  }
};

export const getUserEmail = async () => {
  const user = await Auth.currentUserInfo();
  setLocalStorage("userMail", user.attributes["email"]);
};

export const encryptMemberId = async (encodeString: any) => {
  let memberId = localStorage.getItem("sourceid");
  if (config.APP_NAME === config.BRAND_CURAMLIFE) {
    memberId = localStorage.getItem("member-id");
  }
  let obj = {
    memberId: `memberid=${memberId}&type=&email=${localStorage.getItem(
      "userMail"
    )}&lang=${localStorage.getItem("Language")}`,
  };
  console.log(i18next.language);

  let request = {
    URL: config.URLS.baseAPI + "v1/csrportal/idencryption",
    data: obj,
    brand: config.APP_NAME,
  };
  try {
    var response = await apiService.default.post(request);
    return response.data;
  } catch (err) {
    console.log("Internal server error.");
  }
};

export const getRxSimpleShareData = async () => {
  const memberSSN = await getMemberHealthIdCard();
  let data = {
    type: "family",
    memberSSN,
  };
  try {
    const URL = `${config.URLS.baseAPI}${config.URLS.getCSRAddOns}`;
    const { data: apiResponse } = await apiService.default.post({
      URL,
      data,
    });

    let counterHealthTool = 0;
    let counterRxSimpleShare = 0;
    let isAddonToolExists: any = [
      "UHS Health Tools",
      "Advanced Health Tools",
      "Health Tools",
    ].map((tool: string) => tool?.toLowerCase());
    let isShareExists: any = [];
    let BoolisAddonToolExists = false;
    apiResponse.forEach((item: any) => {
      isShareExists = ["UHS RxSimpleShare", "RxSimpleShare"].map(
        (tool: string) => tool?.toLowerCase()
      );
      BoolisAddonToolExists = false;
      if (isAddonToolExists.includes(item?.addon?.toLowerCase())) {
        BoolisAddonToolExists = true;
      }
      isShareExists = isShareExists.includes(item?.addon?.toLowerCase());
      isAddonToolExists && counterHealthTool++;
      isShareExists && counterRxSimpleShare++;
    });

    const findRxSimpleData = apiResponse.find(
      (obj: any) =>
        ["UHS RxSimpleShare", "RxSimpleShare"].includes(obj.addon) &&
        obj.status === "AC"
    );
    const findHealToolData = apiResponse.find(
      (obj: any) =>
        ["UHS Health Tools", "Advanced Health Tools", "Health Tools"].includes(
          obj.addon
        ) && obj.status === "AC"
    );
    localStorage.setItem(
      "HealthTool",
      JSON.stringify(Boolean(findHealToolData))
    );
    return {
      rxSimpleShareActive: Boolean(findRxSimpleData),
      counterRxSimpleShare,
      healthToolAddonActive: Boolean(findHealToolData),
      counterHealthTool,
      addOns: apiResponse,
    };
  } catch (error: any) {
    console.log("Error: getRxSimpleShareData ", error);
    return Promise.reject({
      message: error?.message || messages.SOMETHING_WRONG,
    });
  }
};
